export default "__VITE_ASSET__FFwDb$mD__"